import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import OutlinedInput from '@mui/material/OutlinedInput'
import Select from '@mui/material/Select'
import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'

import CloseIcon from '@mui/icons-material/Close'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import { USER_ASSIGN_EMULATOR_URL, USER_URL } from '../constants'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}))

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
            color: (theme) => theme.palette.blue
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  )
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired
}
const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    sx: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
      backgroundColor: '#FFFFFF', // Set dropdown background to white
      fontSize: '12px !important',
      fontFamily: 'Poppins, sans-serif !important',
      color: '#000000', // Text color black
      '& .MuiMenuItem-root.Mui-selected': {
        backgroundColor: '#FFFFFF !important' // Ensure selected item remains white
      },
      '& .MuiMenuItem-root.Mui-selected:hover': {
        backgroundColor: '#F0F0F0 !important' // Light gray on hover
      },
      '&::-webkit-scrollbar': {
        width: '8px'
      },
      '&::-webkit-scrollbar-track': {
        background: '#FFFFFF'
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#A9A9A9',
        borderRadius: '4px'
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#A9A9A9'
      }
    }
  }
}

const UserAssignDropDown = (props) => {
  const {
    showToast,
    open,
    close,
    emulatorToAssignUser,
    handleAssignedUserToEmulator
  } = props

  const [userName, setuserName] = React.useState([])
  const [users, setUsers] = useState([])
  const [selectedUserId, SetSelectedUserId] = useState()

  const handleUserSelect = async (userId) => {
    try {
      const { success, error, data } = await setUserToEmulator(
        emulatorToAssignUser.id,
        selectedUserId
      )

      if (success) {
        if (emulatorToAssignUser != null) {
          handleAssignedUserToEmulator(success, error, data)
        } else {
          handleAssignedUserToEmulator(success, error, null)
        }
        showToast('User Assign', 'success')
      } else {
        showToast(error || 'Failed to add user', 'error')
      }
    } catch (error) {
      console.error('Error occurred while adding user:', error)
    }
  }

  const handleChange = (event) => {
    const {
      target: { value }
    } = event

    SetSelectedUserId(value)
    setuserName(value)
  }

  const setUserToEmulator = async (emulatorId, UserId) => {
    const toAssign = {
      user: { id: UserId },
      emulatorDetails: { id: emulatorId }
    }

    const token = localStorage.getItem('token')
    const response = await fetch(USER_ASSIGN_EMULATOR_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(toAssign)
    })
    if (!response.ok || response.status !== 200) {
      return { success: false, error: 'Failed to assign user', data: null }
    }
    const result = await response.json()
    return { success: true, error: null, data: result }
  }

  useEffect(() => {
    // Fetch data from API
    const fetchUsers = async () => {
      const token = localStorage.getItem('token')
      try {
        const response = await fetch(USER_URL, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        })
        if (!response.ok || response.status !== 200) {
          return { success: false, error: 'Invalid credentials' }
        } else {
          const responseData = await response.text()

          const deserializedData = JSON.parse(responseData)

          setUsers(deserializedData)
          return { success: true, error: null }
        }
      } catch (error) {
        console.error('User Data Error: ' + error)
      }
    }

    fetchUsers()
  }, [open])

  return (
    <div>
      <BootstrapDialog
        onClose={close}
        aria-labelledby="customized-dialog-title"
        open={open}
        className="align-select-assign-user-popup"
        sx={{
          '& .MuiPaper-root': { borderRadius: '4px' } // Applies radius to modal container
        }}
      >
        <BootstrapDialogTitle
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontWeight: '100px'
          }}
          id="customized-dialog-title"
          className="global-font"
          onClose={close}
        >
          Select User
        </BootstrapDialogTitle>
        <DialogContent
          dividers
          sx={{
            padding: '0rem !important'
          }}
        >
          <FormControl
            sx={{ m: 1, width: 300, margin: '1.5rem', padding: 0 }}
            className="align-select-user-mobile"
          >
            <label className="form-label">
              <span className="generate-modal-sub-head"> Users </span>
              <span className="text-danger">*</span>
            </label>
            <Select
              labelId="demo-multiple-name-label"
              id="demo-multiple-name"
              value={userName}
              onChange={handleChange}
              input={
                <OutlinedInput
                  label="Name"
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#ccc' // Default border color
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#A3A3A3', // Border color on hover
                      boxShadow: '1px 1px 7px 0px #00000017'
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#A3A3A3', // Border color on focus (click)
                      borderWidth: '0.1px',
                      boxShadow: '1px 1px 7px 0px #00000017'
                    },
                    '& .MuiSelect-select': {
                      paddingTop: '8px', // Fix top spacing issue
                      paddingBottom: '8px', // Keep consistent height
                      minHeight: 'unset', // Prevent extra height
                      paddingRight: '32px', // Apply padding-right
                      borderTop: '1px solid #A3A3A3', // Apply border-top
                      fontSize: '14px', // Font size
                      fontFamily: 'Poppins, sans-serif !important'
                    }
                  }}
                />
              }
              MenuProps={MenuProps}
            >
              {users
                ?.filter((userData) => userData.status === 'ENABLED')
                .map((user) => (
                  <MenuItem
                    key={user.id}
                    value={user.id}
                    sx={{
                      fontSize: '14px', // Font size
                      fontFamily: 'Poppins, sans-serif !important', // Font family
                      color: '#000000', // Text color (black)
                      backgroundColor: '#FFFFFF', // Background color (white)
                      fontWeight: '400',
                      '&:hover': {
                        backgroundColor: '#F0F0F0' // Light gray on hover
                      }
                    }}
                  >
                    {user.firstName} {user.lastName}
                  </MenuItem>
                ))}
            </Select>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: '#00C72E',
                  color: '#ffff',
                  border: 'none',
                  width: '97px',
                  height: '38px',
                  borderRadius: '4px',
                  marginTop: '2rem'
                }}
                className="align-add-btn-select-user"
                onClick={() => handleUserSelect()}
              >
                Add
              </Button>
            </div>
          </FormControl>
        </DialogContent>
      </BootstrapDialog>
    </div>
  )
}
export default UserAssignDropDown
